module.exports = __webpack_public_path__ + "2903a874c562aeec1560ebd3e91b58d0.jpg";